import { create } from 'zustand'

/**
 * UI notification + confirm merkezi — native alert/confirm yerine.
 *
 * Kullanım:
 *   import { toast, confirm } from '../stores/uiStore'
 *   toast.success('Kaydedildi')
 *   toast.error('Hata oluştu')
 *   const ok = await confirm({ title: 'Silinsin mi?', message: '...', variant: 'danger' })
 *   if (ok) { ... }
 */

export const useUIStore = create((set, get) => ({
  toasts: [],           // [{id, type, title, message}]
  confirmState: null,   // {title, message, variant, resolve}

  addToast: (t) => {
    const id = Math.random().toString(36).slice(2)
    set((s) => ({ toasts: [...s.toasts, { id, ...t }] }))
    const ttl = t.duration ?? 4500
    if (ttl > 0) setTimeout(() => get().removeToast(id), ttl)
    return id
  },
  removeToast: (id) => set((s) => ({ toasts: s.toasts.filter((x) => x.id !== id) })),

  showConfirm: (opts) =>
    new Promise((resolve) => {
      set({ confirmState: { ...opts, resolve } })
    }),
  closeConfirm: (result) => {
    const { confirmState } = get()
    if (confirmState?.resolve) confirmState.resolve(result)
    set({ confirmState: null })
  },
}))

// Proxy helpers
export const toast = {
  success: (title, message) => useUIStore.getState().addToast({ type: 'success', title, message }),
  error: (title, message) => useUIStore.getState().addToast({ type: 'error', title, message, duration: 8000 }),
  // KALICI popup — kendiliğinden KAPANMAZ, kullanıcı çarpıya basana kadar durur.
  // Gelen bildirimler (bell) için kullanılır; opts: { type, onClick }
  // opts.badge = {label, cls} → başlığın yanında küçük rozet (ör. firma adı).
  // Bildirim hangi firmadan geldiği okunmadan anlaşılsın diye eklendi.
  persistent: (title, message, opts = {}) =>
    useUIStore.getState().addToast({
      type: opts.type || 'info', title, message, duration: 0,
      onClick: opts.onClick, badge: opts.badge || null,
    }),
  info: (title, message) => useUIStore.getState().addToast({ type: 'info', title, message }),
  // Tıklanabilir kısa bildirim — "Geri al" gibi tek aksiyon (varsayılan 5 sn).
  action: (title, message, onClick, duration = 5000) =>
    useUIStore.getState().addToast({ type: 'info', title, message, onClick, duration }),
  warning: (title, message) => useUIStore.getState().addToast({ type: 'warning', title, message }),
}

export const confirm = (opts) => useUIStore.getState().showConfirm(opts)
